import { render, staticRenderFns } from "./FNSIDPreview.vue?vue&type=template&id=00b33e6d&scoped=true&"
import script from "./FNSIDPreview.vue?vue&type=script&lang=js&"
export * from "./FNSIDPreview.vue?vue&type=script&lang=js&"
import style0 from "./FNSIDPreview.vue?vue&type=style&index=0&id=00b33e6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b33e6d",
  null
  
)

export default component.exports